import Vue from "vue"
import WechatPlugin from 'vux/src/plugins/wechat/index.js'


/**
* @author Bruce
* @time 2019-07-15
* @description 微信JS-SDK相关的处理方法
*/

export default {
/**
* 判断当前客户端版本是否支持指定JS接口
* @param jsApiList 接口列表
*/
checkJsApi(jsApiList) {
return new Promise((resolve, reject) => {
WechatPlugin.$wechat.checkJsApi({
jsApiList: jsApiList, // 需要检测的JS接口列表
success: function (res) {


let checkResult = res.checkResult;
if (typeof (checkResult) == "string") {

checkResult = JSON.parse(checkResult);
}
resolve(checkResult)
},
fail: function (err) {
reject(err)
}
})
})
},
/**
* 选择图片或者拍照接口
*/
chooseImage() {
return new Promise((resolve, reject) => {
WechatPlugin.$wechat.chooseImage({
count: 1, // 默认9
sizeType: ["compressed"], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
success: function (res) {


console.log("chooseImage result:------------------")
console.log(res)
resolve(res);
},
fail: function (err) {
reject(err);
}
});
});
},
/**
* 图片上传接口
* @param localId 需要上传的图片id，由chooseImage接口获取，chooseImage返回的是个数组列表，这里仅需要其中一项就可以，例如：localIds[0]
*/
uploadImage(localId) {
return new Promise((resolve, reject) => {
WechatPlugin.$wechat.uploadImage({
localId: localId, // 需要上传的图片的本地ID，由chooseImage接口获得
isShowProgressTips: 1, // 默认为1，显示进度提示
success: function (res) {
console.log("uploadImage result:------------------")
console.log(res)

resolve(res);
},
fail: function (err) {
reject(err);
}
});
})
},
/**
* 获取本地图片接口
*/
getLocalImgData(localId) {
return new Promise((resolve, reject) => {
WechatPlugin.$wechat.getLocalImgData({
localId: localId, // 图片的localID
success: function (res) {
var localData = res.localData; 
if (localData.substr(0, 5) != 'data:') {
localData = 'data:image;base64,' + localData;
}

resolve(localData);
},
fail: function (err) {
reject(err);
}
});
});
},
/**
* 选择图片并且上传，返回上传后的id
*/
chooseAndUpload() {
return new Promise((resolve, reject) => {
let jsApiList = ["chooseImage", "uploadImage"];
this.checkJsApi(jsApiList)
.then(res => {
if (res.chooseImage && res.uploadImage) {

return this.chooseImage();
} else {
Vue.$vux.alert.show({
content: "当前客户端不支持相关微信图片接口，请更换设备操作或联系客服！"
});
}
})
.then(res => {

return this.uploadImage(res.localIds[0]);
})
.then(res => {


resolve(res);
})
.catch(err => {
console.log(err);
Vue.$vux.toast.text(err);
reject(err)
});
})
},
/**
* 微信分享操作
* @param title 分享标题
* @param desc 分享描述
* @param link 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
* @param imgUrl 分享图标
*/
handleWxShare(title, desc, link, imgUrl) {
let jsApiList = ["updateAppMessageShareData"]; 
this.checkJsApi(jsApiList)
.then(res => {



if (
res.updateAppMessageShareData &&
WechatPlugin.$wechat.updateAppMessageShareData
) {
WechatPlugin.$wechat.updateAppMessageShareData({
title: title,
desc: desc,
link: link,
imgUrl: imgUrl,
success: function () {

console.log("分享微信朋友成功");
}
});
WechatPlugin.$wechat.updateTimelineShareData({
title: title,
desc: desc,
link: link,
imgUrl: imgUrl,
success: function () {

console.log("分享朋友圈成功");
}
});
} else {
WechatPlugin.$wechat.onMenuShareTimeline({
title: title,
desc: desc,
link: link,
imgUrl: imgUrl,
success: function () {

console.log("分享朋友圈成功");
}
});
WechatPlugin.$wechat.onMenuShareAppMessage({
title: title,
desc: desc,
link: link,
imgUrl: imgUrl,
success: function () {

console.log("分享微信朋友成功");
}
});
WechatPlugin.$wechat.onMenuShareQQ({
title: title,
desc: desc,
link: link,
imgUrl: imgUrl,
success: function () {

console.log("分享QQ好友成功");
},
cancel: function () {

}
});
}
}).catch(err => {
console.log(err);
Vue.$vux.toast.text(err);
})
},
/**
* 发起微信支付
*/
chooseWXPay(wxPayData) {
return new Promise((resolve, reject) => {
WechatPlugin.$wechat.chooseWXPay({
appId: wxPayData.appId, // 这里要传公众号appId。注释时间2020-07-23
timestamp: wxPayData.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
nonceStr: wxPayData.nonceStr, // 支付签名随机串，不长于 32 位
package: wxPayData.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
signType: wxPayData.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
paySign: wxPayData.paySign, // 支付签名
success: function (res) {

resolve(res);
},
fail: function (err) {
reject(err);
},
cancel: function (res) {

resolve(res)
}
});
})
}
}



// WEBPACK FOOTER //
// ./src/utils/wxJsSdk.js